import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import { help, type HelpArticle } from "@/lib/help";

const HelpContext = createContext<{
  articles: HelpArticle[];
  loading: boolean;
  failed: boolean;
  retry: () => void;
}>({
  articles: [],
  loading: false,
  failed: false,
  retry: () => undefined,
});

export function HelpProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState({
    articles: [] as HelpArticle[],
    loading: true,
    failed: false,
  });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    void help
      .articles(controller.signal)
      .then((articles) => {
        if (!controller.signal.aborted)
          setState({ articles, loading: false, failed: false });
      })
      .catch(() => {
        if (!controller.signal.aborted)
          setState({ articles: [], loading: false, failed: true });
      });
    return () => controller.abort();
  }, [attempt]);
  return (
    <HelpContext.Provider
      value={{
        ...state,
        retry: () => {
          setState((previous) => ({
            ...previous,
            loading: true,
            failed: false,
          }));
          setAttempt((previous) => previous + 1);
        },
      }}
    >
      {children}
    </HelpContext.Provider>
  );
}

export function useHelp() {
  return useContext(HelpContext);
}
